import { Box, Grid, GridSpacing } from '@mui/material';
import React from 'react';
import useHiddenHeaderFooter from '../../hooks/useHiddenHeaderFooter';
import { ChildrenProps } from '../../../common/interfaces/childrenProps';
import { RaterStyles } from '../../styles/rater';

interface PageContainerProps extends ChildrenProps {
  spacing?: GridSpacing;
  center?: true;
  helpOpen?: boolean;
}

export const RaterPageContainer = ({ children, spacing, center, helpOpen }: PageContainerProps): React.JSX.Element => {
  const { classes } = RaterStyles();
  useHiddenHeaderFooter(classes.container);

  return (
    <Box textAlign={center ? 'center' : 'left'} className={!helpOpen ? classes.container : classes.raterContainerHelp}>
      <Grid container justifyContent="center" className={classes.raterContainer} spacing={spacing ? spacing : 0}>
        {children}
      </Grid>
    </Box>
  );
};
